import React from "react";
import { Container, Accordion } from "react-bootstrap";
import { motion } from "framer-motion";

const FaqSection = () => {
  const faqs = [
    {
      question: "Majistral App’e nasıl üye olabilirim?",
      answer:
        "Ana sayfadaki 'Üye Ol' butonuna tıklayarak kayıt formunu doldurabilirsiniz. Kayıt ve ödeme sonrası yönetici onayının ardından hesabınız aktif hale gelir.",
    },
    {
      question: "Üyelik onayı ne kadar sürer?",
      answer:
        "Ödemeniz yapılıp dekontunuz gönderildikten sonra genellikle 24 saat içinde onay işlemi tamamlanır.",
    },
    {
      question: "Majistral veri tabanına herkes erişebilir mi?",
      answer:
        "Hayır. Formül veri tabanına yalnızca onaylı üyeler erişebilir. Ziyaretçiler sadece blog içeriklerini görüntüleyebilir.",
    },
    {
      question: "Ödemeyi nasıl yapabilirim?",
      answer:
        "Üyelik sayfasında belirtilen IBAN üzerinden EFT/Havale yöntemiyle ödeme yapabilir, dekontunuzu iletmek için bizimle WhatsApp üzerinden iletişime geçebilirsiniz.",
    },
  ];

  return (
    <section id="faq" className="py-5" style={{ backgroundColor: "#F9FAFA" }}>
      <Container>
        <motion.div
          className="text-center mb-5"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <h2 className="fw-bold" style={{ color: "#2D8A7A" }}>
            Sıkça Sorulan Sorular
          </h2>
          <p className="text-muted lead">
            Üyelik, ödeme ve platform kullanımıyla ilgili merak ettikleriniz.
          </p>
        </motion.div>

        <Accordion defaultActiveKey="0" className="faq-accordion">
          {faqs.map((item, index) => (
            <Accordion.Item eventKey={index.toString()} key={index}>
              <Accordion.Header>{item.question}</Accordion.Header>
              <Accordion.Body>{item.answer}</Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Container>
    </section>
  );
};

export default FaqSection;